import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlay } = FiIcons;

const VideoCard = ({ id, index }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const thumbnailUrl = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{
        duration: 0.4,
        ease: "easeOut",
        // Only apply stagger delay to the first batch, new ones should pop in fast
        delay: index < 3 ? index * 0.1 : 0
      }}
      className="aspect-[9/16] w-full max-w-[260px] sm:max-w-[320px] md:max-w-full mx-auto bg-black rounded-2xl overflow-hidden shadow-2xl border-4 border-slate-900 relative group cursor-pointer"
      onClick={() => setIsPlaying(true)}
    >
      {!isPlaying ? (
        <>
          <img
            src={thumbnailUrl}
            alt={`Client Success Story ${index + 1}`}
            className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-300"
            loading="lazy"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform duration-300">
              <SafeIcon icon={FiPlay} className="text-3xl text-black ml-1" />
            </div>
          </div>
          <div className="absolute top-4 left-4 pointer-events-none">
            <div className="bg-yellow-500 text-black text-xs font-black px-2 py-1 uppercase rounded shadow-sm">
              Success Story #{index + 1}
            </div>
          </div>
        </>
      ) : (
        <iframe
          className="w-full h-full"
          src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`}
          title={`Client Win ${index + 1}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      )}
    </motion.div>
  );
};

export default VideoCard;